const removeSlashes = (value: string) => value.replace(/\//g, '')

export type NumericDateFormat = 'MM/DD/YYYY' | 'DD/MM/YYYY' | 'YYYY/MM/DD'
export interface DateFormatType {
  format: NumericDateFormat
  parseDate: (date: string, preserveSlash?: boolean) => { day: string; month: string; year: string }
}

export function getCustomDateFormat(customFormat?: NumericDateFormat): DateFormatType {
  const format = customFormat ?? 'MM/DD/YYYY'

  const getDay = (date: string, preserveSlash: boolean) => {
    const dayIndex = date.includes('/') ? format.indexOf('D') : removeSlashes(format).indexOf('D')
    const hasTrailingSlash = date[dayIndex + 2] === '/'
    const endIndex = hasTrailingSlash && preserveSlash ? dayIndex + 3 : dayIndex + 2
    return date.substring(dayIndex, endIndex)
  }
  const getMonth = (date: string, preserveSlash: boolean) => {
    const monthIndex = date.includes('/') ? format.indexOf('M') : removeSlashes(format).indexOf('M')
    const hasTrailingSlash = date[monthIndex + 2] === '/'
    const endIndex = hasTrailingSlash && preserveSlash ? monthIndex + 3 : monthIndex + 2
    return date.substring(monthIndex, endIndex)
  }
  const getYear = (date: string, preserveSlash: boolean) => {
    const yearIndex = date.includes('/') ? format.indexOf('Y') : removeSlashes(format).indexOf('Y')
    const hasTrailingSlash = date[yearIndex + 4] === '/'
    const endIndex = hasTrailingSlash && preserveSlash ? yearIndex + 5 : yearIndex + 4
    return date.substring(yearIndex, endIndex)
  }

  return {
    format,
    parseDate: (date = '', preserveSlash = false) => {
      return {
        day: getDay(date, preserveSlash),
        month: getMonth(date, preserveSlash),
        year: getYear(date, preserveSlash),
      }
    },
  }
}
